import { useContext } from "react";
import { toolbarStoreIdContext } from "../ToolbarRootContext.js";
function useToolbarStoreId() {
  const context = useContext(toolbarStoreIdContext);
  if (context === null) throw new Error("useToolbarStoreId requires a ToolbarRoot ancestor.");
  return context;
}
export {
  useToolbarStoreId
};
//# sourceMappingURL=useToolbarStoreId.js.map
